import normalAxios from "axios";
import axios from "../core/https";
import { uriToHttps } from "../core/utils/ipfs";
import { INft, INftActivity, INftMetadata, INftSale } from "../core/models/nft";
import { IUser } from "../core/models/user";
import { UserFavorite } from "../core/models/user-favorite";
import { Quote } from "../core/models/quote";
import { ICollection } from "../core/models/collection";
interface IGetNftDetailResponse extends INft {
  quotes: Quote[];
  collection: ICollection | null;
  owners: { user: IUser; quantityOwned: string }[];
}

const getMetatdata = (uri: string) => {
  const httpsUri = uriToHttps(uri);
  if (!httpsUri) return null;

  return normalAxios.get<INftMetadata>(httpsUri);
};

const getNftDetail = (tokenAddress: string, tokenId: string) =>
  axios.get<IGetNftDetailResponse>(`/marketplace/nfts/${tokenAddress}/${tokenId}`, {
    headers: {
      requireToken: "0",
    },
  });

const getListedNftsByCollection = (params: {
  sort_field?: string;
  sort_direction?: string;
  page?: number;
  size?: number;
  collection: string;
}) =>
  axios.get<INft[]>(`/marketplace/nfts/by-collection`, {
    headers: {
      requireToken: "0",
    },
    params,
  });

const getNfts = (params?: { sort_field?: string; sort_direction?: string; page?: number; size?: number }) =>
  axios.get<{ name: string; nfts: INft[]; token_address: string }[]>(`/marketplace/nfts/`, {
    headers: {
      requireToken: "0",
    },
    params,
  });

const getNtfsByAccount = (account: string) =>
  axios.get<INft[]>(`/marketplace/nfts/by-account/${account}`, {
    headers: {
      requireToken: "0",
    },
  });

const getNtfsByCollection = (collection: string) =>
  axios.get<INft[]>(`/marketplace/collections/nfts`, {
    headers: {
      requireToken: "0",
    },
    params: {
      collection,
    },
  });

const getActivities = (tokenAddress: string, tokenId: string) =>
  axios.get<INftActivity[]>(`/marketplace/nfts/${tokenAddress}/${tokenId}/activities`, {
    headers: {
      requireToken: "0",
    },
  });

const getSales = (tokenAddress: string, tokenId: string) =>
  axios.get<INftSale[]>(`/marketplace/nfts/${tokenAddress}/${tokenId}/sales`, {
    headers: {
      requireToken: "0",
    },
  });

const getOwners = (tokenAddress: string, tokenId: string) =>
  axios.get<{ user: IUser; quantityOwned: string }[]>(`/marketplace/nfts/${tokenAddress}/${tokenId}/owners`, {
    headers: {
      requireToken: "0",
    },
  });

const addFavorite = (tokenAddress: string | undefined, tokenId: string | undefined, account: string) =>
  axios.post<boolean>(
    `/marketplace/nfts/add-favorite`,
    {
      type: 0,
      token_address: tokenAddress,
      token_id: tokenId,
      account: account,
    },
    {
      headers: {
        requireToken: "0",
      },
    }
  );

const removeFavorite = (tokenAddress: string | undefined, tokenId: string | undefined, account: string) =>
  axios.post<boolean>(
    `/marketplace/nfts/remove-favorite`,
    {
      type: 0,
      token_address: tokenAddress,
      token_id: tokenId,
      account: account,
    },
    {
      headers: {
        requireToken: "0",
      },
    }
  );

const checkFavoritedUser = (tokenAddress: string | undefined, tokenId: string | undefined, account: string) =>
  axios.get<boolean>(`/marketplace/nfts/check-favorited-user`, {
    headers: {
      requireToken: "0",
    },
    params: {
      type: 0,
      token_address: tokenAddress,
      token_id: tokenId,
      account: account,
    },
  });

const getNumberFavorite = (tokenAddress: string | undefined, tokenId: string | undefined) =>
  axios.get<number>(`/marketplace/nfts/number-favorite`, {
    headers: {
      requireToken: "0",
    },
    params: {
      type: 0,
      token_address: tokenAddress,
      token_id: tokenId,
    },
  });

const getFavoritedUsers = (
  tokenAddress: string | undefined,
  tokenId: string | undefined,
  page: number,
  pageSize: number
) =>
  axios.get<UserFavorite[]>(`/marketplace/nfts/favorited-users`, {
    headers: {
      requireToken: "0",
    },
    params: {
      type: 0,
      token_address: tokenAddress,
      token_id: tokenId,
      page: page,
      pageSize: pageSize,
    },
  });

const create = (body: INft) =>
  axios.post(`/marketplace/nfts`, body, {
    // headers: {
    //   requireToken: "0",
    // },
  });

export const nftService = {
  getMetatdata,
  getNftDetail,
  getListedNftsByCollection,
  getNtfsByAccount,
  getNfts,
  getNtfsByCollection,
  getSales,
  getOwners,
  getActivities,
  addFavorite,
  removeFavorite,
  checkFavoritedUser,
  getNumberFavorite,
  getFavoritedUsers,
  create,
};
